import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { ShipmentWaybillEndpoint } from '../../constants/shipment-waybill-endpoint';
import { Observable } from 'rxjs';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { ShipmentWaybillDemurrageAndDetention } from '../../models/shipment-waybill-demurrage-and-detention.model';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillDemurrageAndDetentionInfoService {
  constructor(private http: WrapperHttpService) {}

  getInfoData(internalWaybillId: string): Observable<ShipmentWaybillDemurrageAndDetention> {
    return this.http
      .withLoading()
      .get<ShipmentWaybillDemurrageAndDetention>(
        `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
          ShipmentWaybillEndpoint.ContainerCharges
        }?${getQueryStringFromObject({ internalWaybillId })}`,
      );
  }
}
